import {useMutation, useQueryClient} from "@tanstack/react-query";
import {deleteAccountAddressInfo} from "../../../../../api/correspondent/CorresspondentApi";
import {useModal} from "../../../../../hooks";

interface Props {
    afterCallback: () => any
}

export default function useDeleteAccountAddressInfo({afterCallback}: Props) {
    const queryClient = useQueryClient();
    const {handleModal} = useModal();

    const {mutate} = useMutation({
        mutationFn: (data: { id: string }[]) => deleteAccountAddressInfo(data),
        onSuccess: (res) => {
            if (res.data.code === "0000") {
                handleModal({
                    isOpen: true,
                    contents: res.data.msg,
                    type: "alert",
                    closeAction: () => {
                        queryClient.invalidateQueries({
                            queryKey: ["readAccountAddressList"],
                        });
                        afterCallback()
                    }
                })
            } else {
                handleModal({
                    isOpen: true,
                    contents: res.data.msg,
                    type: "alert",
                })
            }
        },
        onError: (error) => {
            handleModal({
                isOpen: true,
                contents: error.message,
                type: "alert"
            })
        },
    });
    return {mutate};
};
